<template>
  <v-row justify="center" class="pt-4 pb-12 pl-sm-4 pr-sm-4" no-gutters>
    <v-col xl="10" lg="11" md="12" sm="12" cols="10">
      <v-card outlined>
        <v-row no-gutters>
          <v-col xl="8" lg="8" md="7" sm="8" cols="8" class="card-border-right pb-12">
            <v-skeleton-loader type="image" class="image-loader"></v-skeleton-loader>
            <v-skeleton-loader type="image" class="image-loader"></v-skeleton-loader>
            <v-row no-gutters>
              <v-col cols="12" align="left" class="pt-10 px-8 card-border-top">
                <v-skeleton-loader type="text"></v-skeleton-loader>
              </v-col>
              <v-col cols="6" align="left" class="pt-5 px-4">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
              <v-col cols="6" align="left" class="pt-5 px-4">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
              <v-col cols="6" align="left" class="px-4">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
              <v-col cols="6" align="left" class="px-4">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
              <v-col cols="12" align="left" class="pt-8 px-8">
                <v-skeleton-loader type="paragraph"></v-skeleton-loader>
              </v-col>
              <v-col cols="12" align="left" class="pt-5 px-8">
                <v-skeleton-loader type="paragraph"></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-left pt-4 pb-12" xl="4" lg="4" md="5" sm="4" cols="4">
            <div class="px-8">
              <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
              <v-skeleton-loader type="actions"></v-skeleton-loader>
            </div>
            <v-row class="mt-6" no-gutters>
              <v-col cols="12" class="card-border-top px-8 pt-4">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                <div class="mt-2">
                  <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                  <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                </div>
                <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ProductDetailDeskLoader'
}
</script>
